<template>
  <CandidateDocument />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ACTIONS from '@/storeActions';
import CandidateDocument from '@/components/CandidateDocument.vue';

export default {
  name: 'CandidateDocumentPage',
  components: { CandidateDocument },
  computed: {
    ...mapGetters(['currentParticipant']),
    ...mapState({
      participants: (state) => state.runInfo.participants,
      currentParticipantId: (state) => state.currentParticipantId
    }),
  },
  mounted() {
    const self = this;
    if (!this.participants || this.participants.length <= 0 || !this.currentParticipantId || !this.currentParticipant) {
      this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.$i18n.t('Errors.noCurrentParticipantSelected'), color: 'error' })
      this.$router.push({ name: 'overview' })
    }
    if (!this.currentParticipant.documentUrl) {
      this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.$i18n.t('Errors.noParticipantDocuments'), color: 'error' })
      this.$router.push({ name: 'overview' })
    }
  }
}
</script>

<style scoped>

</style>
